import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import("@/components/home")
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    //公共导航
    {
      path: '/leftNav',
      name: 'leftNav',
      component: () => import("@/components/nav/leftNav")
    },
    // 首页导航
    {
      path: '/homeLeftNav',
      name: 'homeLeftNav',
      component: () => import("@/components/nav/homeLeftNav")
    },
    // 首页

    // 关于我们
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import("@/components/aboutUs")
    },

    // 核心业务
    {
      path: '/coreBusiness',
      name: 'coreBusiness',
      component: () => import("@/components/coreBusiness")
    },
    // 核心业务详情
    // 菜花娱乐
    {
      path: '/chyl',
      name: 'chyl',
      component: () => import("@/components/coreBusinessDetail/chyl")
    },
    // 烦立停
    {
      path: '/flt',
      name: 'flt',
      component: () => import("@/components/coreBusinessDetail/flt")
    },
    // 科技金融
    {
      path: '/prhd',
      name: 'prhd',
      component: () => import("@/components/coreBusinessDetail/prhd")
    },
    // 集团品牌ip
    {
      path: '/jtppip',
      name: 'jtppip',
      component: () => import("@/components/coreBusinessDetail/jtppip")
    },
    // 陀螺财经
    {
      path: '/tlcj',
      name: 'tlcj',
      component: () => import("@/components/coreBusinessDetail/tlcj")
    },
    // 陀螺传媒
    {
      path: '/tlcm',
      name: 'tlcm',
      component: () => import("@/components/coreBusinessDetail/tlcm")
    },
    // 陀螺电竞
    {
      path: '/tldj',
      name: 'tldj',
      component: () => import("@/components/coreBusinessDetail/tldj")
    },
    // 陀螺活动
    {
      path: '/tlhd',
      name: 'tlhd',
      component: () => import("@/components/coreBusinessDetail/tlhd")
    },
    // 锐量
    {
      path: '/rl',
      name: 'rl',
      component: () => import("@/components/coreBusinessDetail/rl")
    },
    // 陀螺名片
    {
      path: '/tlmp',
      name: 'tlmp',
      component: () => import("@/components/coreBusinessDetail/tlmp")
    },
    // 陀螺研究院
    {
      path: '/tlyjy',
      name: 'tlyjy',
      component: () => import("@/components/coreBusinessDetail/tlyjy")
    },
    // vr陀螺
    {
      path: '/vrtl',
      name: 'vrtl',
      component: () => import("@/components/coreBusinessDetail/vrtl")
    },
    // 星界互娱
    {
      path: '/xjhy',
      name: 'xjhy',
      component: () => import("@/components/coreBusinessDetail/xjhy")
    },
    //游戏陀螺
    {
      path: '/yxtl',
      name: 'yxtl',
      component: () => import("@/components/coreBusinessDetail/yxtl")
    },
    // 云鹦日历
    {
      path: '/yyrl',
      name: 'yyrl',
      component: () => import("@/components/coreBusinessDetail/yyrl")
    },
    // 必效
    {
      path: '/bx',
      name: 'bx',
      component: () => import("@/components/coreBusinessDetail/bx")
    },
    // 知识产权保护
    {
      path: '/zscqbh',
      name: 'zscqbh',
      component: () => import("@/components/coreBusinessDetail/zscqbh")
    },
    // 陀螺学堂
    {
      path: '/tlxy',
      name: 'tlxy',
      component: () => import("@/components/coreBusinessDetail/tlxy")
    },
    // 陀螺多多
    {
      path: '/tlyx',
      name: 'tlyx',
      component: () => import("@/components/coreBusinessDetail/tlyx")
    },
    // 陀螺多多
    {
      path: '/tuoluodd',
      name: 'tuoluodd',
      component: () => import("@/components/coreBusinessDetail/tuoluodd")
    },
    // 电商mcn
    {
      path: '/dsmcn',
      name: 'dsmcn',
      component: () => import("@/components/coreBusinessDetail/dsmcn")
    },
    // 人才文化
    {
      path: '/talentCulture',
      name: 'talentCulture',
      component: () => import("@/components/talentCulture")
    },
    // 联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import("@/components/contactUs")
    },
    // 新闻
    {
      path: '/news',
      name: 'news',
      component: () => import("@/components/news")
    },
    // 新闻详情
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: () => import("@/components/newsDetails")
    },

  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js